import {createApiRef} from "@backstage/core-plugin-api";
import {RestEndpointMethodTypes} from "@octokit/rest";


export const pequiGithubActionsApiRef = createApiRef<PequiGithubActionsApi>({
    id: 'plugin.pequi-githubactions.service',
});

export type PequiGithubActionsApi = {
    listWorkflowRuns: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        pageSize?: number;
        page?: number;
        branch?: string;
    }) => Promise<
        RestEndpointMethodTypes['actions']['listWorkflowRuns']['response']['data']
    >;

    listBranches: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        page: number;
    }) => Promise<any>;

    getDefaultBranch: (options: {
        hostname?: string;
        owner: string;
        repo: string;
    }) => Promise<
        RestEndpointMethodTypes['repos']['get']['response']['data']['default_branch']
    >;

    createWorkflowDispatch: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        workflow_id: string;
        ref: string;
        inputs: Record<string, string>;
    }) => Promise<void>;

    listJobsForWorkflowRun: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        id: number;
        pageSize?: number;
        page?: number;
    }) => Promise<
        RestEndpointMethodTypes['actions']['listJobsForWorkflowRun']['response']['data']
    >;

    getWorkflowRun: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        id: number;
    }) => Promise<
        RestEndpointMethodTypes['actions']['getWorkflowRun']['response']['data']
    >;

    downloadJobLogsForWorkflowRun: (options: {
        hostname?: string;
        owner: string;
        repo: string;
        runId: number;
    }) => Promise<
        RestEndpointMethodTypes['actions']['downloadJobLogsForWorkflowRun']['response']['data']
    >;
}
